import type { SearchCriteriaParams } from '@/shared/model';

interface StoredCriteriaParams extends Partial<Omit<SearchCriteriaParams, 'departureCity'>> {
  departureCity?: number | { id?: number; name?: string };
}

export default function getLastSearchCriteria(key?: string): SearchCriteriaParams | null {
  if (!key) return null;
  if (typeof localStorage === 'undefined') {
    return null;
  }
  try {
    const stored = JSON.parse(localStorage.getItem(key) || 'null') as StoredCriteriaParams | null;
    if (!stored || typeof stored !== 'object') {
      return null;
    }

    return normalizeCriteriaParams(stored);
  } catch {
    return null;
  }
}

function normalizeCriteriaParams(stored: StoredCriteriaParams): SearchCriteriaParams {
  const params: SearchCriteriaParams = {
    checkInDateRange: { from: '', to: '', ...stored.checkInDateRange },
    countries: stored.countries ?? [],
    departureCity: normalizeDepartureCity(stored.departureCity),
    nightRange: { from: 0, to: 0, ...stored.nightRange },
    touristGroup: { adults: 0, kids: 0, infants: 0, ages: [], ...stored.touristGroup },
  };

  if (stored.resorts?.length) {
    params.resorts = stored.resorts;
  }
  if (stored.hotels?.length) {
    params.hotels = stored.hotels;
  }

  return params;
}

function normalizeDepartureCity(city: StoredCriteriaParams['departureCity']): SearchCriteriaParams['departureCity'] {
  if (typeof city === 'number') {
    return { id: city, name: '' };
  }

  return { id: 0, name: '', ...city };
}
